import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IPublishSocialVideoV1Request } from './publish-social-video-v1-request';
import type { IPublishSocialVideoV1Response } from './publish-social-video-v1-response';
import { publishSocialVideoV1ResponseSchema } from './publish-social-video-v1-response';

export async function publishSocialVideoV1Api(
  body: IPublishSocialVideoV1Request,
): Promise<IValidatedResponse<IPublishSocialVideoV1Response>> {
  return postRequest<IPublishSocialVideoV1Response>({
    path: '/sys/social/v1/posts',
    body,
    schema: publishSocialVideoV1ResponseSchema,
  });
}
